import React, { useEffect, useState } from "react";
import { apiServices } from "../../services/apiServices";
import moment from "moment";

import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import IconButton from "@material-ui/core/IconButton";
import CardHeader from "@material-ui/core/CardHeader";

import Avatar from "@material-ui/core/Avatar";
import DescriptionIcon from "@material-ui/icons/Description";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { useHistory } from "react-router";

import "../../assets/css/customstyles.css";

import { useLocation } from "react-router-dom";
import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#4DB6AC",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

function RecordHistory(props) {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const sessionMetaData = props.programData;
  const currentStage = props.currentStage;
  const values = props.values
  const eventsData =
    navigator.onLine && props.trackentityInstanceDetails &&
    props.trackentityInstanceDetails.enrollments &&
    props.trackentityInstanceDetails.enrollments.length > 0 &&
    props.trackentityInstanceDetails.enrollments[0].events
      ? props.trackentityInstanceDetails.enrollments[0].events
      : !navigator.onLine ? props.trackentityInstanceDetails : [];
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  //const [activeCaseDetails, setActiveCaseDetails] = useState(null);

  const GroupEventData = (arrayData) => {
    // console.log("arrayData",arrayData)
    arrayData.forEach(element => {
      element.groupDate = element.lastUpdated.split("T")[0]; //manually added new Date key for grouping
    });

    let GroupArrData = arrayData.reduce(function (r, a) {
        r[a.groupDate] = r[a.groupDate] || [];
        r[a.groupDate].push(a);
        return r;
    }, Object.create(null));

    // console.log("GroupArrData",GroupArrData)
    return GroupArrData;
  }

  const GroupArr = GroupEventData(eventsData);
  // console.log("eventsData", eventsData, GroupArr)
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  const getTranslatedLabels = (attribute) => {
    if (localStorage.getItem("locale") == "en") {
      //return attribute.displayName;
      return attribute.formName
        ? attribute.formName
        : attribute.displayName
        ? attribute.displayName
        : attribute.description;
    } else if (attribute.translations && attribute.translations.length > 0) {
      //debugger;
      let label = attribute.translations.filter(
        (tanslation) =>
          tanslation.property == "NAME" &&
          tanslation.locale == localStorage.getItem("locale")
      );
      if (label.length > 0) {
        return label[0].value;
      } else {
        //return attribute.displayName;
        return attribute.formName
          ? attribute.formName
          : attribute.displayName
          ? attribute.displayName
          : attribute.description;
      }
    }
    //return attribute.displayName;
    return attribute.formName
      ? attribute.formName
      : attribute.displayName
      ? attribute.displayName
      : attribute.description;
  };

  function createStructure(events) {
    // const dataElements = sessionMetaData.dataElements;
    return events.dataValues.map((values, i) => {
      return sessionMetaData?.programs[0]?.programStages.map((stages) => {
        let filterFieldData = stages.programStageDataElements.filter(
          (obj) =>
            stages.id == events.programStage &&
            obj.dataElement.id == values.dataElement
        );
        let fieldValue = values.value;
        let lastUpdatedDate = values.lastUpdated;
      
        if (filterFieldData.length > 0) {
          const filterShowFlagAttr =
            filterFieldData[0].dataElement.attributeValues.filter(
              (obj) =>
                obj.attribute.displayName == "ShowInTable" &&
                obj.value == "true"
            );

          // console.log("filterShowFlagAttr",filterShowFlagAttr)
          try {
            if (filterFieldData[0].dataElement.valueType == "DATE") {
              //IF VALUE OF DATAELEMENT IS DATE
              fieldValue = moment(values.value).format("YYYY-MM-DD");
            }
            if (
              filterFieldData[0].dataElement.valueType == "ORGANISATION_UNIT"
            ) {
              let orgobj = sessionMetaData.programs[0].organisationUnits.find(
                (o) => o.id == values.value
              );
              if (orgobj) {
                fieldValue = orgobj.displayName;
              }
            }
            if (
              filterFieldData[0].dataElement &&
              filterFieldData[0].dataElement.fieldMask == "Facility Referral"
            ) {
              let stageObj = sessionMetaData.programs[0].programStages.filter(
                (stage) => stage.id == values.value
              );
              fieldValue =
                stageObj.length > 0
                  ? getTranslatedLabels(stageObj[0])
                  : values.value;
            }
            if (filterFieldData[0].dataElement.optionSet) {
              filterFieldData[0].dataElement.optionSet.options.map((option) => {
                if (option.code == values.value) {
                  fieldValue = getTranslatedLabels(option);
                }
              });
            }
          } catch (e) {}

          if (filterShowFlagAttr.length > 0) {
            return (
              <ListItem key={i}>
                <ListItemAvatar>
                  <Avatar>
                    <DescriptionIcon />
                  </Avatar>
                </ListItemAvatar>
                <Typography>
                  <span className="zero servicequestiontitle">
                    {getTranslatedLabels(filterFieldData[0].dataElement)} :{" "}
                  </span>
                  &nbsp;
                  <span className="zero servicequestionanswer">
                    {fieldValue}
                  </span>
                </Typography> 
              </ListItem>
            );
          }
        }
      });
    });
  }

  function getEntityData(events, i, dateVal) {
    // console.log("group event",events)
    const classes = makeStyles((theme) => ({
      root: {
        width: "100%",
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
      },
    }));

    const allStages = props.programData.programs[0].programStages;

    const filterStageEvent = allStages.filter(
      (obj) =>
        obj.id == events.programStage &&
        currentStage.id == obj.id &&
        events.status != "SCHEDULE"
    );

    // console.log("filterStageEvent", filterStageEvent)
    if (!filterStageEvent.length) {
      return null;
    }
    return (   
      <div className="appointment-card">
          <h4>{moment(dateVal).format("LT")}</h4>
          <List className={classes.root}>
            {createStructure(events)}
          </List>
      </div>
    );
  }

  return (
    <section
      className="individualrecord"
      style={{
        backgroundColor: "#fff",
        flexGrow: 1,
        padding: 0,
      }}
    >
      <div className="searchformcontainer">  
        <Grid style={{ marginBottom: "50px" }} className="previous-section">
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="visit-bg"
            >
              <Typography>{t("Previous Visits")}</Typography>
            </AccordionSummary>
          {GroupArr && Object.keys(GroupArr).length > 0 &&
            (() => {
              let structure = [];
              for (const key in GroupArr) {
                  if(GroupArr[key] != null && GroupArr[key].length > 0) { 
                    structure.push(<AccordionDetails className="data-container">
                    <Grid container className="mt-10px mb-10px">
                            <Grid item xs={12} sm={12} md={12} key={key} className="mb-10px">
                              <Accordion
                                expanded={
                                  expanded ===
                                  moment(GroupArr[key][0].lastUpdated).format("MMMM Do YYYY") +
                                    GroupArr[key][0].event
                                }
                                onChange={handleChange(
                                  moment(GroupArr[key][0].lastUpdated).format("MMMM Do YYYY") +
                                    GroupArr[key][0].event
                                )}
                              >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                className="visit-bg"
                              >
                                <Typography className="">
                                  {moment(GroupArr[key][0].lastUpdated).format("MMMM Do YYYY")}
                                </Typography>
                              </AccordionSummary>
                              {GroupArr[key].map((events, i) => {
                                return (
                                  <AccordionDetails>{ getEntityData(events, i, GroupArr[key][i].lastUpdated) }</AccordionDetails>
                                )})}
                              </Accordion>
                            </Grid>
                    </Grid></AccordionDetails>)
                  } 
              }

              return structure;
            })()
          }
          </Accordion>
        </Grid>
      </div>
    </section>
  );
}
export default RecordHistory;
